@if (isShow) {<a style="cursor: pointer;" (click)="gotoTop()">Scroll To</a>}